var _rect, _g, _path, _tspan, _rect2, _rect3, _rect4, _rect5, _rect6, _tspan2, _g2, _rect7, _rect8, _rect9, _rect10, _rect11, _tspan3, _path2, _g3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefinitionsRelationships(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465.02,
    height: 278,
    viewBox: "0 0 123.04 73.555",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.4979 -4.4979)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.27554
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.90563 0 0 .83765 -77.778 2.8863)",
    fill: "#0058ff"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91.28,
    y: 2.3776,
    width: 38.635,
    height: 40.472,
    rx: 1.1686,
    ry: 1.2635,
    fillOpacity: 0.1,
    stroke: "#0058ff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.27554
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0058ff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.1042 0 0 1.1938 84.885 -3.21)",
    x: 7.5882,
    y: 32.974,
    width: 30.087,
    height: 3.175,
    rx: 1.5875,
    ry: 1.5875
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.1042 0 0 1.1938 84.885 -3.21)",
    x: 7.5882,
    y: 27.608,
    width: 30.087,
    height: 3.175,
    rx: 1.5875,
    ry: 1.5875
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.1042 0 0 1.1938 84.885 -3.21)",
    x: 7.5882,
    y: 22.241,
    width: 30.087,
    height: 3.175,
    rx: 1.5875,
    ry: 1.5875
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.1042 0 0 1.1938 84.885 -3.21)",
    x: 7.5882,
    y: 16.875,
    width: 30.087,
    height: 3.175,
    rx: 1.5875,
    ry: 1.5875
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.1042 0 0 1.1938 84.885 -3.21)",
    d: "m8.4766 13.552c-0.1759-0.03263-0.31707-0.16038-0.3707-0.33544-0.0178-0.0581-0.02377-0.1437-0.01396-0.20005 0.01689-0.09701 0.16682-0.59151 0.3112-1.0266 0.02303-0.06937 0.0528-0.12015 0.10112-0.17233 0.07496-0.08097 0.11464-0.10156 0.50166-0.26029 0.12783-0.05243 0.28398-0.11683 0.34702-0.1431 0.18395-0.07666 0.40624-0.16136 0.6413-0.2443l0.07811-0.02755 0.01703 0.0589c0.07483 0.25889 0.5197 1.5654 0.5409 1.5885 0.0032 0.0036 0.0055-0.0045 0.0055-0.01936-6e-5 -0.01401 0.01181-0.28159 0.02638-0.59461l0.02646-0.5691-0.10995-0.21826c-0.04434-0.07365-0.13591-0.19775-0.11787-0.21261 0.01113-0.0092 0.0312 0.0086 0.06046 0.02361 0.12451 0.06232 0.26613 0.11971 0.4406 0.12649 0.19146 0.0074 0.34594-0.05248 0.5078-0.1258 0.03315-0.01552 0.06885-0.04239 0.08231-0.0272 0.01812 0.02045-0.13013 0.20564-0.13235 0.21006l-0.11267 0.22289 0.02739 0.59356c0.01508 0.32645 0.0294 0.59146 0.03184 0.58888 0.01599-0.01692 0.47574-1.369 0.54297-1.5969l0.01456-0.04932 0.21626 0.07905c0.25453 0.09303 0.28093 0.10323 0.51147 0.19747 0.73148 0.29895 0.73962 0.30273 0.81992 0.37937 0.04096 0.03907 0.08785 0.10493 0.10422 0.14639 0.0055 0.0142 0.03057 0.08908 0.05547 0.16638 0.16446 0.51043 0.25889 0.82645 0.27175 0.90934 0.0241 0.15536-0.0457 0.33147-0.17181 0.4335-0.04376 0.03543-0.1233 0.07649-0.18058 0.09331-0.03666 0.01075-0.17296 0.0114-2.5337 0.01242-2.022 8.48e-4 -2.5035-5.27e-4 -2.5402-0.0073zm2.4334-2.6402c-0.29862-0.06501-0.58668-0.26163-0.79654-0.54363-0.11209-0.15067-0.225-0.37323-0.28504-0.56184-0.01421-0.04458-0.01554-0.04642-0.03137-0.04206-0.03018 0.0084-0.08086 0.0035-0.10776-0.01018-0.10224-0.05216-0.17276-0.21814-0.20613-0.48518-0.02038-0.16295-0.0055-0.24513 0.05391-0.29738 0.03767-0.03317 0.0782-0.04491 0.15494-0.04491h0.06085l-0.0045-0.1049c-0.01599-0.3706-0.01442-0.4639 0.0098-0.58868 0.10178-0.52491 0.53522-0.92556 1.0688-0.98796 0.38327-0.04482 0.72523 0.05511 1.0085 0.29478 0.18552 0.15694 0.33501 0.40838 0.39078 0.65732 0.02898 0.12936 0.03334 0.20868 0.02457 0.44844-0.0043 0.1173-0.0078 0.22851-0.0077 0.24713l1.39e-4 0.03389h0.0606c0.09994 0 0.15146 0.02448 0.18631 0.08851 0.03414 0.06273 0.03619 0.15034 0.0077 0.33108-0.04417 0.28011-0.15223 0.44218-0.28186 0.42275-0.01516-0.0023-0.03019-0.0041-0.03339-4e-3 -0.0032 7.9e-5 -0.01653 0.03153-0.02961 0.06989-0.13254 0.38861-0.35985 0.7008-0.65205 0.89544-0.07515 0.05007-0.20249 0.11392-0.28403 0.14247-0.13279 0.04645-0.22116 0.0577-0.30685 0.03905z",
    strokeWidth: 0.0070192
  })), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.96174 1.0398)",
    x: 105.32928,
    y: 12.386542,
    fontFamily: "Jamrul",
    fontSize: "7.5944px",
    strokeDasharray: "0.303777, 0.607555, 0.303777, 1.21511",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.30378,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 105.32928,
    y: 12.386542,
    fill: "#0058ff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "7.5944px",
    strokeWidth: 0.30378
  }, "Contact"))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.90563 0 0 .83765 -34.387 41.78)",
    fill: "#3d4193"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    transform: "translate(-1.287e-6)",
    x: 91.28,
    y: 2.3776,
    width: 38.635,
    height: 40.472,
    rx: 1.1686,
    ry: 1.2635,
    fillOpacity: 0.1,
    stroke: "#3d4193",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.27554
  })), /*#__PURE__*/React.createElement("g", null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.1042 0 0 1.1938 39.306 -49.128)",
    x: 48.866,
    y: 66.07,
    width: 30.087,
    height: 3.175,
    rx: 1.5875,
    ry: 1.5875
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.1042 0 0 1.1938 39.306 -49.128)",
    x: 48.866,
    y: 71.437,
    width: 30.087,
    height: 3.175,
    rx: 1.5875,
    ry: 1.5875
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.1042 0 0 1.1938 39.306 -49.128)",
    x: 48.866,
    y: 60.704,
    width: 30.087,
    height: 3.175,
    rx: 1.5875,
    ry: 1.5875
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.1042 0 0 1.1938 39.306 -49.128)",
    x: 48.866,
    y: 55.338,
    width: 30.087,
    height: 3.175,
    rx: 1.5875,
    ry: 1.5875
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.1042 0 0 1.1938 39.306 -49.128)",
    x: 56.697472,
    y: 51.940178,
    fontFamily: "Jamrul",
    fontSize: "6.6146px",
    strokeDasharray: "0.264583, 0.529167, 0.264583, 1.05833",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 56.697472,
    y: 51.940178,
    fill: "#3d4193",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "6.6146px",
    strokeWidth: 0.26458
  }, "Project"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0081919 0 0 .0088567 91.404 3.7803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m878.91 798.85v199.64h-519.64v-754.55h160.24v39.516h199.15v-39.516h160.24v80.363c7.6367-0.72656 15.395-1.0898 23.152-1.0898 5.6953 0 11.395 0 16.969 0.60547v-119.88h-600v834.55h600v-239.15c-5.5742 0-11.273 0.72656-16.969 0.72656-7.7578 4e-3 -15.516-0.48438-23.152-1.2109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.03 402.73v-79.516h-120v119.15h120zm-40 0h-40v-39.758h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.03 641.03v-79.516h-120v119.15h120zm-40 0h-40v-39.637h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m978.06 463.33-141.46 140.36-56.484-56.121-28.363 28.121 56.605 56.121 28.242 28.121 28.363-28.121 141.46-140.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.03 800.06h-40v119.15h120v-119.15zm40 79.395h-40v-39.152h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m619.03 184.67c5.1367-4e-3 10.07 1.9961 13.762 5.5703 3.6875 3.5742 5.8359 8.4453 5.9961 13.578h40c-0.9375-20.773-12.559-39.582-30.723-49.707s-40.273-10.125-58.438 0c-18.16 10.125-29.785 28.934-30.719 49.707h40.242c0.125-5.1641 2.2852-10.07 6.0039-13.656 3.7227-3.5859 8.707-5.5586 13.875-5.4922z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m879.03 362.97c-52.633 0.28906-103 21.453-140.04 58.844s-57.734 87.953-57.531 140.59c0.20312 52.633 21.285 103.04 58.613 140.14 37.332 37.105 87.859 57.879 140.49 57.762 52.633-0.11719 103.07-21.117 140.23-58.387 37.164-37.27 58.023-87.766 57.992-140.4-0.2266-52.801-21.383-103.35-58.832-140.57-37.445-37.219-88.129-58.07-140.93-57.973zm0 357.33v4e-3c-42.051-0.28906-82.266-17.246-111.83-47.148-29.562-29.906-46.055-70.312-45.863-112.36 0.19141-42.051 17.055-82.305 46.891-111.94 29.836-29.633 70.207-46.219 112.25-46.125 42.051 0.0976 82.348 16.867 112.05 46.637 29.699 29.766 46.379 70.098 46.383 112.15-0.1602 42.254-17.094 82.711-47.07 112.49-29.98 29.773-70.555 46.43-112.81 46.301z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.96571 0 0 .83746 1.6768 2.8868)",
    fill: "#ff8c00"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 91.28,
    y: 2.3776,
    width: 38.635,
    height: 40.472,
    rx: 1.0959,
    ry: 1.2637,
    fillOpacity: 0.1,
    stroke: "#ff8c00",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.27554
  })), /*#__PURE__*/React.createElement("g", null, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.0355 0 0 1.1941 -1.9043 -3.8478)",
    x: 91.782,
    y: 33.503,
    width: 30.087,
    height: 3.175,
    rx: 1.5875,
    ry: 1.5875
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.0355 0 0 1.1941 -1.9043 -3.8478)",
    x: 91.782,
    y: 28.137,
    width: 30.087,
    height: 3.175,
    rx: 1.5875,
    ry: 1.5875
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.0355 0 0 1.1941 -1.9043 -3.8478)",
    x: 91.782,
    y: 22.771,
    width: 30.087,
    height: 3.175,
    rx: 1.5875,
    ry: 1.5875
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.0355 0 0 1.1941 -1.9043 -3.8478)",
    x: 91.782,
    y: 17.404,
    width: 30.087,
    height: 3.175,
    rx: 1.5875,
    ry: 1.5875
  })), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 108.26129,
    y: 11.991571,
    fontFamily: "Jamrul",
    fontSize: "6.4726px",
    strokeDasharray: "0.294209, 0.588419, 0.294209, 1.17683",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.29421,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 108.26129,
    y: 11.991571,
    fill: "#ff8c00",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "6.4726px",
    strokeWidth: 0.29421
  }, "Company"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m96.42 7.9897-0.51885-0.14581-0.91594 0.67762v4.115h-0.82269v-0.6728c0.02561 0.0066 0.05223 0.0099 0.07952 0.0099 0.20078 0 0.36338-0.18743 0.36338-0.41885 0-0.12881-0.05041-0.24411-0.12979-0.32096 0.07934-0.07685 0.12979-0.19215 0.12979-0.32095 0-0.19698-0.11784-0.36206-0.27671-0.40694-0.02535-0.15831-0.14565-0.27825-0.29018-0.27825-0.14462 0-0.26502 0.11994-0.29018 0.27814-0.15887 0.04488-0.27687 0.20997-0.27687 0.40706 0 0.12881 0.05041 0.24411 0.12985 0.32095-0.07943 0.07685-0.12985 0.19216-0.12985 0.32096 0 0.23142 0.1627 0.41885 0.36338 0.41885 0.02729 0 0.05384-0.0034 0.07943-0.0099v0.6728h-0.411v0.28622h6.6087v-0.28622h-0.4111v-0.67288c0.02562 0.0066 0.05222 0.01005 0.07954 0.01005 0.20078 0 0.36338-0.18743 0.36338-0.41885 0-0.12881-0.0503-0.24411-0.12968-0.32095 0.0793-0.07685 0.12968-0.19215 0.12968-0.32095 0-0.19698-0.11783-0.36206-0.27669-0.40694-0.02544-0.15831-0.14566-0.27825-0.29018-0.27825-0.14463 0-0.26502 0.11994-0.29019 0.27814-0.15877 0.04488-0.27686 0.20996-0.27686 0.40706 0 0.12881 0.05059 0.24411 0.12994 0.32095-0.07939 0.07685-0.12994 0.19215-0.12994 0.32095 0 0.23142 0.1627 0.41885 0.36338 0.41885 0.02732 0 0.05383-0.0034 0.07936-0.0099v0.6728h-0.8225v-6.3745l-0.97824-0.2748-1.232 0.91141v1.0911zm-0.53489 4.6468v-4.4412l-0.65172 0.48201v3.9591h0.65172zm1.8172 0v-6.3413l-0.0055-0.0016-1.0287 0.76098v5.582h1.0341z",
    fillRule: "evenodd",
    strokeWidth: 0.0017812
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.26458 .26458)",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.129 62.702 25.081-1.13e-4 1.1e-4 -24.079",
    fill: "none",
    stroke: "#4d4d4d",
    strokeWidth: 0.2738
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4d4d4d",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.128 63.928 1.8518-1.0902 7.06e-4 -0.26344-1.8524 1.0815z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.129 61.476 1.8518 1.0902-0.01055 0.26344-1.8412-1.0815z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.89 61.434-1.8518 1.0902 0.01055 0.26344 1.8412-1.0815z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.89 63.871-1.8518-1.0902 0.01055-0.26344 1.8412 1.0815z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m21.463 38.631v24.025l26.427-1.1e-4",
    fill: "none",
    stroke: "#4d4d4d",
    strokeWidth: 0.26458
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.26591 .26458)",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0.5,
    fontFamily: "'Coming Soon'",
    fontSize: "3.7042px",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("text", {
    x: 41.506336,
    y: 22.354601,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 41.506336,
    y: 22.354601,
    fill: "#000000",
    fillOpacity: 0.5,
    fontFamily: "'Coming Soon'",
    fontSize: "3.7042px",
    strokeWidth: 0.26458
  }, "Many"))), /*#__PURE__*/React.createElement("text", {
    x: 41.506336,
    y: 27.11393,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 41.506336,
    y: 27.11393,
    fill: "#000000",
    fillOpacity: 0.5,
    fontFamily: "'Coming Soon'",
    fontSize: "3.7042px",
    strokeWidth: 0.26458
  }, "Employees"))), /*#__PURE__*/React.createElement("text", {
    x: 72.896332,
    y: 27.113876,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 72.896332,
    y: 27.113876,
    fill: "#000000",
    fillOpacity: 0.5,
    fontFamily: "'Coming Soon'",
    fontSize: "3.7042px",
    strokeWidth: 0.26458
  }, "Employer"))), /*#__PURE__*/React.createElement("text", {
    x: 37.096649,
    y: 61.330902,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 37.096649,
    y: 61.330902,
    fill: "#000000",
    fillOpacity: 0.5,
    fontFamily: "'Coming Soon'",
    fontSize: "3.7042px",
    strokeWidth: 0.26458
  }, "Many"))), /*#__PURE__*/React.createElement("text", {
    x: 24.993185,
    y: 66.288101,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 24.993185,
    y: 66.288101,
    fill: "#000000",
    fillOpacity: 0.5,
    fontFamily: "'Coming Soon'",
    fontSize: "3.7042px",
    strokeWidth: 0.26458
  }, "Assignments"))), /*#__PURE__*/React.createElement("text", {
    x: 85.218437,
    y: 61.330784,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 85.218437,
    y: 61.330784,
    fill: "#000000",
    fillOpacity: 0.5,
    fontFamily: "'Coming Soon'",
    fontSize: "3.7042px",
    strokeWidth: 0.26458
  }, "Many"))), /*#__PURE__*/React.createElement("text", {
    x: 85.218407,
    y: 66.320717,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 85.218407,
    y: 66.320717,
    fill: "#000000",
    fillOpacity: 0.5,
    fontFamily: "'Coming Soon'",
    fontSize: "3.7042px",
    strokeWidth: 0.26458
  }, "Projects"))), /*#__PURE__*/React.createElement("text", {
    x: 109.22061,
    y: 46.021606,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 109.22061,
    y: 46.021606,
    fill: "#000000",
    fillOpacity: 0.5,
    fontFamily: "'Coming Soon'",
    fontSize: "3.7042px",
    strokeWidth: 0.26458
  }, "Account"))), /*#__PURE__*/React.createElement("text", {
    x: 109.10468,
    y: 42.069126,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 109.10468,
    y: 42.069126,
    fill: "#000000",
    fillOpacity: 0.5,
    fontFamily: "'Coming Soon'",
    fontSize: "3.7042px",
    strokeWidth: 0.26458
  }, "One"))), /*#__PURE__*/React.createElement("text", {
    x: 22.278671,
    y: 42.06926,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 22.278671,
    y: 42.06926,
    fill: "#000000",
    fillOpacity: 0.5,
    fontFamily: "'Coming Soon'",
    fontSize: "3.7042px",
    strokeWidth: 0.26458
  }, "One"))), /*#__PURE__*/React.createElement("text", {
    x: 22.278671,
    y: 46.054039,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 22.278671,
    y: 46.054039,
    fill: "#000000",
    fillOpacity: 0.5,
    fontFamily: "'Coming Soon'",
    fontSize: "3.7042px",
    strokeWidth: 0.26458
  }, "Point Person"))), /*#__PURE__*/React.createElement("text", {
    x: 81.897888,
    y: 22.310846,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 81.897888,
    y: 22.310846,
    fill: "#000000",
    fillOpacity: 0.5,
    fontFamily: "'Coming Soon'",
    fontSize: "3.7042px",
    strokeWidth: 0.26458
  }, "One")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m39.735 22.545 1.8518 1.0902-0.01055 0.26344-1.8412-1.0815z",
    fill: "#4d4d4d",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m39.735 24.979 1.8518-1.0902-0.01055-0.26344-1.8412 1.0815z",
    fill: "#4d4d4d",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m39.735 23.762 49.693-0.0039",
    fill: "none",
    stroke: "#4d4d4d",
    strokeWidth: 0.26458
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefinitionsRelationships);
export default __webpack_public_path__ + "static/media/definitions-relationships.91a019e938b7164003bfe8a4f3c7c8a7.svg";
export { ForwardRef as ReactComponent };